import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIssueOutOfStock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22 20V4H2v16h20ZM20 6H4v12h3v-8h10v8h3V6Zm-9 6H9v6h2v-6Zm2 6h2v-6h-2v6Z",
		fill: "currentColor"
	})
});
export default SvgIssueOutOfStock;
